import { Tween, Easing } from "@tweenjs/tween.js";

/**
 * @param valueName vue prop to animate
 * @param endValue
 * @param duration in ms
 */
export function tweenProperty<P extends string>(
  this: { [p in P]: number },
  valueName: P,
  endValue: number,
  duration = 200
) {
  const startValue = this[valueName];

  const value = { [valueName]: startValue };
  const tween = new Tween(value)
    .to({ [valueName]: endValue }, duration)
    .easing(Easing.Quadratic.InOut)
    .onUpdate(() => {
      this[valueName] = Math.round(value[valueName] * 100) / 100;
    })
    .start();
  
  function animate() {
    if (tween.update()) {
      requestAnimationFrame(animate);
    }
  }

  animate();
}

// create a default export
export default {
  tweenProperty
};